const accordion = {
	init: function() {
		this.toggleEvent();
	},

	toggleAccordion: (event) => {
		event.currentTarget.parentNode.classList.toggle('opened')
    },

	toggleEvent: function() {
		const accordionItems = document.querySelectorAll(".accordion__items .accordion__item .item__title");
		if( accordionItems ) {
			accordionItems.forEach(item => {
				item.addEventListener('click', this.toggleAccordion);
			});
		}
	}
};

export default accordion;